import { closeQAAssistant } from './actions/closeQAAssistant';
import {
  MSG_NAME_FROM_IFRAME,
  MSG_NAME_TO_IFRAME,
  sendMessageToIframe,
} from './handleIframeMessage/handleIframeMessage';

export const insertCloseButton = (logo: HTMLElement, cleanABTastyNotificationListener) => {
  const closeButton = document.createElement('div');
  closeButton.setAttribute('width', '20');
  closeButton.setAttribute('height', '20');
  closeButton.setAttribute('viewBox', '0 0 20 20');
  closeButton.setAttribute('id', 'qaClose');
  closeButton.classList.add('qa-assistant-close');
  closeButton.addEventListener('mousedown', () => {
    sendMessageToIframe({ name: MSG_NAME_TO_IFRAME.SegmentClickClosing });
    window.removeEventListener('message', cleanABTastyNotificationListener);
    setTimeout(() => {
      closeQAAssistant();
      window.postMessage(
        {
          name: MSG_NAME_FROM_IFRAME.MinimizeQaAssistantClose,
        },
        '*'
      );
    }, 0);
  });
  closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#3100BF" d="M15 6.238L13.762 5 10 8.761 6.238 5 5 6.238 8.762 10 5 13.761 6.238 15 10 11.238 13.762 15 15 13.761 11.238 10z"/></svg>`;
  logo.append(closeButton);
};
